import { NAME} from './constants';

export const allCompanies = state => state[NAME].companies;
